export const storytellingFragment = `
  fragment storytellingFragment on StorytellingRecord {
    moduleFormat {
      ...moduleFormatFragment
    }
    columns {
      button {
        ...buttonFragment
      }
      card {
        title
        content {
          blocks {
            ... on ListWithIconsBlockRecord {
              ...listWithIconsFragment
            }
          }
          links
          value
        }
      }
      image {
        responsiveImage {
          ...responsiveImageFragment
        }
      }
      subtitle
      title
      video {
        ...cmsVideoFragment
      }
    }
    headingProps {
      textStyle
    }
    subtitle
    tag
    title
  }
`;
